import SocialAuthComponent from '../components/SocialAuth/viewer/SocialAuth';
import SocialAuthController from '../components/SocialAuth/viewer/SocialAuth.controller';


const SocialAuth = {
  component: SocialAuthComponent,
  controller: SocialAuthController
};


export const components = {
  ['SocialAuth']: SocialAuth
};

